import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import Workspace from '~/javascript/components/landing_pages/Workspace.vue'

/**
 * P13 ERB -> Vue bridge for the standalone Made.ly landing editor. ERB passes
 * only the authorized workspace id (empty until the owner creates one), the
 * native endpoint metadata and the session CSRF token; every read and write
 * then goes through the native Ajax API.
 */
export default class extends Controller {
  static values = {
    workspaceId: String,
    endpoints: { type: Object, default: {} },
    csrfToken: String
  }

  connect() {
    this.vue = createApp(Workspace, {
      workspaceId: this.workspaceIdValue,
      endpoints: this.endpointsValue,
      csrfToken: this.csrfTokenValue || document.querySelector('meta[name="csrf-token"]')?.content || ''
    })
    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
    this.vue = null
  }
}
